<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 1 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-tools pb-5 pt-2">
          <div class="row">
            <div class="col-12">
              <a class="btn btn-dark btn-sm btn-new"> Behavioral statistics </a>
              <a class="btn btn-dark btn-sm btn-new"> Total interactions </a>
              <a class="btn btn-dark btn-sm btn-new">
                Non-purchase decisions
              </a>
              <a class="btn btn-dark btn-sm btn-new">
                Step with more friction
              </a>
              <a class="btn btn-dark btn-sm btn-new">
                Customers left without completing
              </a>
              <a class="btn btn-dark btn-sm btn-new"> AI recommends </a>
            </div>
            <!-- <div class="col-6">
                      <h2><strong>CUSTOMER CHARGES</strong></h2>
                    </div> -->
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">chat</i>
            </div>
            <h4 class="card-title">Interacción #1</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="client"
                      >Client</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="client"
                      formControlName="client"
                    />
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="platform"
                      >Platform</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="platform"
                      formControlName="platform"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                  </div>
                </div>
                <div class="col-5 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="talkTime"
                      >Talk Time</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="talkTime"
                      formControlName="talkTime"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-7 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="bookingStep"
                      >Booking Step</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="bookingStep"
                      formControlName="bookingStep"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="summary"
                      >Summary</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="summary"
                      formControlName="summary"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="conclusions"
                      >Conclusions</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="conclusions"
                      formControlName="conclusions"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="notes">Notes</label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="notes"
                      formControlName="notes"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-md-12">
                  <button class="btn btn-dark btn-sm btn-end">
                    Complete conversation
                  </button>
                  <button class="btn btn-dark btn-sm btn-end">Export</button>
                  <button class="btn btn-dark btn-sm btn-end">Report</button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
